import { render, staticRenderFns } from "./NodeDropoffPath.vue?vue&type=template&id=284d148e&scoped=true"
import script from "./NodeDropoffPath.vue?vue&type=script&lang=js"
export * from "./NodeDropoffPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d148e",
  null
  
)

export default component.exports